/**
 * Created by Ivan on 24.05.2025
 */

const SuitCardTutorial = function () {
    return new TutorialScenario(SuitCardTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createPlayCardStep(SuitCardTutorial.CONFIG.tutorial[0]),
            TileGameTutorialHelper.createPlayCardStep(SuitCardTutorial.CONFIG.tutorial[1])
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(SuitCardTutorial.NAME);
            Game.currentGame.hand.setCards(SuitCardTutorial.CONFIG.handValues);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(SuitCardTutorial.NAME)
    });
};

SuitCardTutorial.NAME = "suitCard";
SuitCardTutorial.CONFIG = {
    handValues: ["9h"],
    tutorial: [{
        force: "SuitCard1TutorialMessage",
        filter: [SuitCard]
    }, {
        force: "SuitCard2TutorialMessage",
        filter: ["2"]
    }]
};
